const PURL_AGENT_CODE = 'PurlAgentCode';
const PURL_AGENT_CODE_NEW = 'NEWPurlAgentCode';
const PURL_AGENT_DATA = 'PurlAgentData';
const ENROLL_BANNER_WEB = 'EnrollBannerWeb';
const ENROLL_BANNER_MOBILE = 'EnrollBannerMobile';

export {
    PURL_AGENT_CODE,
    PURL_AGENT_DATA,
    PURL_AGENT_CODE_NEW,
    ENROLL_BANNER_WEB,
    ENROLL_BANNER_MOBILE
};
